import styled from 'styled-components';

export const FormGroup = styled.div`
  width: 100%;
  &.is-invalid {
    margin-bottom: auto !important;
  }
`;

export const FormGroupFlex = styled(FormGroup)`
  flex: ${({flex}) => flex ?? 1};
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: ${({ disabled }) => (disabled ? '#A8A8A8' : '#161414')};
`
